import { toFirstLetterLowercased } from '@gov-nx/utils/common';
import { useGlobalLocale } from './useGlobalLocale';

/**
 * Returns a formatter that prefixes a submit-button label with "Autorizovat a "
 * (and lowercases the original label's first letter) when the service has
 * authorization configured. Used for both the button text and its aria-label.
 */
export const useAuthorizedLabel = () => {
	const { t } = useGlobalLocale();

	return (label: string, isAuthorizationEnforced: boolean): string =>
		isAuthorizationEnforced
			? `${t('akce.autorizovat-a')} ${toFirstLetterLowercased(label)}`
			: label;
};
